import { array, number } from 'prop-types';

function DictionaryMatching({ dictionary = [], value }) {
  const findObj = dictionary?.find((item) => item.val === value?.toString());

  return <span>{findObj?.name ?? '-'}</span>;
}

export default DictionaryMatching;
DictionaryMatching.propTypes = {
  dictionary: array,
  value: number,
};

DictionaryMatching.defaultProps = {
  dictionary: [],
};
